import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex max-w-7xl items-center justify-between py-3" }
const _hoisted_2 = { class: "h-8 w-8 stroke-[3px]" }
const _hoisted_3 = { class: "hidden md:block" }
const _hoisted_4 = { class: "flex items-center justify-center gap-x-1 font-normal md:text-sm lg:gap-2 lg:text-base" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Features ", -1)
const _hoisted_7 = { class: "h-5 w-5 stroke-[4px]" }
const _hoisted_8 = {
  key: 1,
  class: "absolute -left-12 top-16 z-10 w-[220px] rounded-md border bg-white p-3 shadow-md"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "rounded-md px-4 py-3 hover:bg-slate-300"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://nerddevs.com/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " About Us ")
  ])
], -1)
const _hoisted_11 = { class: "hidden rounded-md bg-[#436EAF] px-4 py-2 text-lg font-bold text-white hover:bg-[#6a90c9]" }
const _hoisted_12 = {
  key: 1,
  class: "absolute right-0 top-18 z-20 mr-6 w-[220px] rounded-md bg-white p-4 font-medium shadow-md md:hidden"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Features ", -1)
const _hoisted_14 = { class: "h-6 w-6 stroke-[4px]" }
const _hoisted_15 = {
  key: 0,
  class: "absolute right-9 top-30 z-10 w-[220px] rounded-md border bg-white p-3 shadow-md"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "w-full rounded-md px-4 py-3 text-left hover:bg-slate-300"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://nerddevs.com/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " About Us ")
  ])
], -1)
const _hoisted_18 = { class: "mt-2 hidden w-full rounded-md bg-[#436EAF] px-4 py-3 font-bold text-white hover:bg-[#6a90c9]" }

import {
  Bars3Icon,
  ChevronDownIcon,
  ChevronUpIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import {
  computed,
  ref,
} from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import FullPageButton from '@/components/Helper/FullPageButton.vue';
import NavLogoWithText from '@/components/NavBar/NavLogoWithText.vue';
import {
  handleAxiosError,
  redirectUserAfterLogin,
} from '@/helpers';
import {
  allTemplates,
} from '@/helpers/constants/landingPage';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicHeader',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isLoginRoute = computed(() => route.path === '/auth/login');

const authStore = useStore.auth;

const user = computed(() => authStore.user);
const redirectUrl = computed(() => (route.query.redirect || '') as string);

const isMenuOpen = ref(false);
const isTemplatesNonMobileOpen = ref(false);
const isTemplatesMobileOpen = ref(false);

const selectedTemplate = ref('');

async function handleTemplateClick(template: string): Promise<void> {
  selectedTemplate.value = template;

  isTemplatesNonMobileOpen.value = false;
  isTemplatesMobileOpen.value = false;

  if (!user.value) {
    router.push('/dashboard/chat/new');
  } else {
    try {
    // redirect according to role
      const redirection = await redirectUserAfterLogin(user.value, redirectUrl.value);

      await router.push(redirection.route);
    } catch (e: any) {
      handleAxiosError(e);
    }
  }
}

function handleFullPageBtnClick(): void {
  isTemplatesMobileOpen.value = false;
  isMenuOpen.value = false;
}

function onLoginClick(): void {
  const path = `/auth/${isLoginRoute.value ? 'signup' : 'login'}`;

  router.push(path);

  if (isMenuOpen.value) {
    isMenuOpen.value = false;
  }
}

function onMenuClick(path: string): void {
  if (path.startsWith('http')) {
    window.open(path, '_blank');
    return;
  }

  if (path.startsWith('#')) {
    router.push({
      path: '/', hash: path,
    });
    return;
  }

  router.push(path);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavLogoWithText),
    _createElementVNode("button", {
      type: "button",
      class: "rounded-full p-1 hover:bg-slate-400 md:hidden",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (isMenuOpen.value)
          ? (_openBlock(), _createBlock(_unref(XMarkIcon), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(Bars3Icon), { key: 1 }))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md px-4 py-3 hover:bg-slate-300",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/')))
          }, " Home ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["flex items-center gap-1 rounded-md px-4 py-3 hover:bg-slate-300", { 'bg-gray-300 font-semibold': isTemplatesNonMobileOpen.value }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isTemplatesNonMobileOpen.value = !isTemplatesNonMobileOpen.value))
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (isTemplatesNonMobileOpen.value)
                ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(ChevronDownIcon), { key: 1 }))
            ])
          ], 2),
          (isTemplatesNonMobileOpen.value)
            ? (_openBlock(), _createBlock(FullPageButton, {
                key: 0,
                class: "z-10",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (isTemplatesNonMobileOpen.value = false))
              }))
            : _createCommentVNode("", true),
          (isTemplatesNonMobileOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allTemplates), (template) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: template.pngImgSrc,
                    type: "button",
                    class: "w-full cursor-pointer rounded-md p-2 text-left hover:bg-slate-400",
                    onClick: ($event: any) => (handleTemplateClick(template.title))
                  }, _toDisplayString(template.title), 9, _hoisted_9))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md px-4 py-3 hover:bg-slate-300",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (onMenuClick('#pricing')))
          }, " Pricing ")
        ]),
        _hoisted_10,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md px-4 py-3 hover:bg-slate-300",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onMenuClick('#contact-us')))
          }, " Contact ")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/dashboard/chat/new')))
            }, " Try Now ")
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md bg-[#436EAF] px-4 py-2 text-lg font-bold text-white hover:bg-[#6a90c9]",
            onClick: onLoginClick
          }, _toDisplayString(isLoginRoute.value ? 'Sign up' : 'Log in'), 1)
        ])
      ])
    ]),
    (isTemplatesMobileOpen.value || isMenuOpen.value)
      ? (_openBlock(), _createBlock(FullPageButton, {
          key: 0,
          class: "z-10",
          onClick: handleFullPageBtnClick
        }))
      : _createCommentVNode("", true),
    (isMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "w-full rounded-md px-4 py-3 text-left hover:bg-slate-300",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push('/')))
            }, " Home ")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["flex w-full items-center justify-between gap-1 rounded-md px-4 py-3 text-left hover:bg-slate-300", { 'bg-gray-300 font-semibold': isTemplatesMobileOpen.value }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (isTemplatesMobileOpen.value = !isTemplatesMobileOpen.value))
            }, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (isTemplatesMobileOpen.value)
                  ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(ChevronDownIcon), { key: 1 }))
              ])
            ], 2),
            (isTemplatesMobileOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allTemplates), (template) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: template.pngImgSrc,
                      type: "button",
                      class: "w-full cursor-pointer rounded-md p-2 text-left hover:bg-slate-400",
                      onClick: ($event: any) => (handleTemplateClick(template.title))
                    }, _toDisplayString(template.title), 9, _hoisted_16))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "w-full rounded-md px-4 py-3 text-left hover:bg-slate-300",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (onMenuClick('#pricing')))
            }, " Pricing ")
          ]),
          _hoisted_17,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "w-full rounded-md px-4 py-3 text-left hover:bg-slate-300",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (onMenuClick('#contact-us')))
            }, " Contact ")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(router).push('/dashboard/chat/new')))
              }, " Try Now ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "mt-2 w-full rounded-md bg-[#436EAF] px-4 py-3 font-bold text-white hover:bg-[#6a90c9]",
              onClick: onLoginClick
            }, _toDisplayString(isLoginRoute.value ? 'Sign up' : 'Log in'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})